export default __webpack_public_path__ + "static/media/68_desktop.54660a69.jpg";